<template>
    <div class="field is-horizontal">
        <div class="field-label is-normal">
            <label class="label">Year</label>
        </div>
        <div class="field-body">
            <div class="field">
                <div class="control">
                    <div class="select is-fullwidth">
                        <select v-model="minYear">
                            <option v-for="year in years">{{ year }}</option>
                        </select>
                        <div class="advance-dropdown"><i class="fa fa-angle-down"></i></div>
                    </div>
                </div>
            </div>
            <div class="field">
                <div class="control">
                    <div class="select is-fullwidth">
                        <select v-model="maxYear">
                            <option v-for="year in years">{{ year }}</option>
                        </select>
                        <div class="advance-dropdown"><i class="fa fa-angle-down"></i></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        components: {

        },
        data() {
            return {
                years: [],
            }
        },
        computed: {
            minYear: {
                get: function () {
                    return this.$store.getters.getQueryYearMin
                },
                set: function (value) {
                    this.$store.dispatch('addNewYearRangeMinValue', value)
                }
            },
            maxYear: {
                get: function () {
                    return this.$store.getters.getQueryYearMax
                },
                set: function (value) {
                    this.$store.dispatch('addNewYearRangeMaxValue', value)
                }
            }
        },
        methods: {
            generateYearsArrays() {
                let minOffset = 0, maxOffset = 80; // Change to whatever you want
                let thisYear = (new Date()).getFullYear();
                let years = [];

                for (let i = minOffset; i <= maxOffset; i++) {
                    years.push(thisYear - i);
                }

                this.years = years
            }
        },
        created() {
            this.generateYearsArrays()
        }
    }

</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Auctions/Advance/Inputs/Year.vue